// Custom client loader that prefers a single combined page-data file.
// This lets the browser fetch /page-data/all-page-data.json once instead
// of many individual page-data.json files, while falling back to the
// default behavior if anything goes wrong.

export const onClientEntry = () => {
  if (typeof window === 'undefined') return
  if (!window.___loader || typeof window.___loader.loadPageDataJson !== 'function') return

  const loader = window.___loader
  const originalLoadPageDataJson = loader.loadPageDataJson.bind(loader)

  let allPageDataPromise = null

  const getAllPageData = () => {
    if (!allPageDataPromise) {
      allPageDataPromise = fetch('/page-data/all-page-data.json', {
        credentials: 'same-origin',
      })
        .then(res => (res.ok ? res.json() : null))
        .catch(() => null)
    }
    return allPageDataPromise
  }

  loader.loadPageDataJson = async pagePath => {
    try {
      const allData = await getAllPageData()
      if (allData) {
        // Normalize pagePath keys: '/' for home, '/path/' for others.
        let key = pagePath === '/' ? '/' : pagePath
        if (!key.endsWith('/') && key !== '/') {
          key = `${key}/`
        }

        const data = allData[key]
        if (data) {
          return data
        }
      }
    } catch (e) {
      // Ignore and fall back to Gatsby's default loader.
    }

    return originalLoadPageDataJson(pagePath)
  }
}
